import { features } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">为什么选择51吃瓜</h2>
          <p className="text-sm text-foreground-600">四大核心优势，让吃瓜与众不同</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 mx-auto mb-4">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}